import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";

const ContributorAuthContext = createContext(null);

export const ContributorAuthProvider = ({ children }) => {
  const [contributor, setContributor] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/auth/contributor-session`,
          { withCredentials: true }
        );
        if (isMounted && res.data?.success) {
          setContributor(res.data.user);
        }
      } catch (_) {
        // not logged in
      } finally {
        if (isMounted) setLoading(false);
      }
    })();
    return () => {
      isMounted = false;
    };
  }, []);

  const loginContributor = async (email, password) => {
    const res = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/api/contributor/contributor-login`,
      { email, password },
      { withCredentials: true }
    );
    if (res.data?.success) {
      setContributor(res.data);
      return res.data;
    }
    throw new Error(res.data?.message || "Contributor login failed");
  };

  const logoutContributor = async () => {
    try {
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/auth/contributor-logout`,
        {},
        { withCredentials: true }
      );
    } catch (_) {
      // ignore
    } finally {
      setContributor(null);
    }
  };

  const value = useMemo(
    () => ({ contributor, setContributor, loading, loginContributor, logoutContributor }),
    [contributor, loading]
  );

  return (
    <ContributorAuthContext.Provider value={value}>
      {children}
    </ContributorAuthContext.Provider>
  );
};

export const useContributorAuth = () => useContext(ContributorAuthContext);


